// Page-scroll lock shared across all open modal surfaces (BottomSheet, Wizard),
// ref-counted so the page behind a dialog can't scroll and a stacked second
// surface doesn't unlock the page when the first closes. The viewport scroller is
// <html>, so we hide its overflow and pad the body by the scrollbar width to avoid
// a content jump when the scrollbar disappears (desktop). overscroll-behavior on
// each surface's own scroller (responsive.css) stops scroll-chaining at its edges.
//
// Kept in one module (not private to a component) so every overlay shares ONE
// counter — otherwise a Wizard stacked over a BottomSheet, each with its own
// counter, would unlock the page the moment either one closes.
let scrollLockCount = 0;
let savedHtmlOverflow = '';
let savedBodyPaddingRight = '';

export function lockPageScroll() {
  if (scrollLockCount === 0) {
    const html = document.documentElement;
    const scrollbarW = window.innerWidth - html.clientWidth;
    savedHtmlOverflow = html.style.overflow;
    savedBodyPaddingRight = document.body.style.paddingRight;
    html.style.overflow = 'hidden';
    if (scrollbarW > 0) document.body.style.paddingRight = `${scrollbarW}px`;
  }
  scrollLockCount += 1;
}

export function unlockPageScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1);
  if (scrollLockCount === 0) {
    document.documentElement.style.overflow = savedHtmlOverflow;
    document.body.style.paddingRight = savedBodyPaddingRight;
  }
}
